// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.axRgRr_3ipCxjl0vOP8f{flex:1;height:100%;width:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;padding:17px}.kstgbTSjLPv0m3L0Fv0i{display:flex;justify-content:center;width:100%;gap:17px}.g8kRkmnD8fxaE75_dkCT{display:flex;flex-direction:column;max-width:600px;flex:1;gap:17px}.g8kRkmnD8fxaE75_dkCT button{margin:0;border-width:1px}.g8kRkmnD8fxaE75_dkCT button span{width:100%}.rQxRHg877j_aDf6AJZjp{display:flex;gap:20px;flex-direction:column;cursor:pointer}.rQxRHg877j_aDf6AJZjp.Mdq3jwHilDnRdOUHr86F{border:1px solid #8496b9;box-shadow:0 1px 2px rgba(184,186,202,.25);border-radius:24px;padding:10px}.rQxRHg877j_aDf6AJZjp.Mdq3jwHilDnRdOUHr86F.uD9f3dKu0t1y8GLWiq6v{border:1px solid #131a4f}.rQxRHg877j_aDf6AJZjp.Mdq3jwHilDnRdOUHr86F.rpJsJR7TbFIWuPhrL5iB{border:1px solid #1ec8fa}.rQxRHg877j_aDf6AJZjp.Mdq3jwHilDnRdOUHr86F.rpJsJR7TbFIWuPhrL5iB.uD9f3dKu0t1y8GLWiq6v{background:red}.rQxRHg877j_aDf6AJZjp.Mdq3jwHilDnRdOUHr86F.NJ3gdMVTYL3VsR5q3aJ2{border:1px solid #da003e;background:#ffcece}.rQxRHg877j_aDf6AJZjp.dnxMlJg5I0idbDXQ3uZd button{width:85%;margin:auto}.rQxRHg877j_aDf6AJZjp.rsgdc4AVXKGtHgn4u_43{cursor:initial}.rQxRHg877j_aDf6AJZjp.rsgdc4AVXKGtHgn4u_43>div{display:flex;justify-content:center}.rQxRHg877j_aDf6AJZjp button{border-width:2px}.rQxRHg877j_aDf6AJZjp.Qjfe0bgI7EI0ehCxj6Kp.uD9f3dKu0t1y8GLWiq6v button{background:#fff;border-color:#141941;color:#141941}.rQxRHg877j_aDf6AJZjp.Qjfe0bgI7EI0ehCxj6Kp button{border-color:#edf4ff;color:#141941}.rQxRHg877j_aDf6AJZjp.Qjfe0bgI7EI0ehCxj6Kp:hover button{border-color:#8496b9;color:#141941;background-color:rgba(0,0,0,0)}.rQxRHg877j_aDf6AJZjp.rpJsJR7TbFIWuPhrL5iB.uD9f3dKu0t1y8GLWiq6v button{background:#1ec8fa;border-color:#1ec8fa;color:#fff}.rQxRHg877j_aDf6AJZjp.rpJsJR7TbFIWuPhrL5iB button{border-color:#1ec8fa}.rQxRHg877j_aDf6AJZjp.NJ3gdMVTYL3VsR5q3aJ2.uD9f3dKu0t1y8GLWiq6v button{background:#fe5779;border-color:#fe5779;color:#fff}.rQxRHg877j_aDf6AJZjp.NJ3gdMVTYL3VsR5q3aJ2 button{border-color:#fe5779}._qR1bv1nqKwOJr2NiWpi{height:200px;background-repeat:no-repeat;background-position:center;border-radius:16px}._qR1bv1nqKwOJr2NiWpi.ybkB2GepA7qNSa21FsUk{background-size:100% 100%}._qR1bv1nqKwOJr2NiWpi.YUOqXuq4Q7KZONomHoc2{background-size:contain}._qR1bv1nqKwOJr2NiWpi.p_YJwGjxRxZ4QiBp3jop{background-size:cover}.Xe3U6sh4wiTXgNJfwetJ{pointer-events:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `Qjfe0bgI7EI0ehCxj6Kp`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `rpJsJR7TbFIWuPhrL5iB`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `NJ3gdMVTYL3VsR5q3aJ2`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `axRgRr_3ipCxjl0vOP8f`,
	"wrapper": `kstgbTSjLPv0m3L0Fv0i`,
	"column": `g8kRkmnD8fxaE75_dkCT`,
	"item": `rQxRHg877j_aDf6AJZjp`,
	"itemImage": `Mdq3jwHilDnRdOUHr86F`,
	"active": `uD9f3dKu0t1y8GLWiq6v`,
	"itemTextImage": `dnxMlJg5I0idbDXQ3uZd`,
	"itemAudio": `rsgdc4AVXKGtHgn4u_43`,
	"image": `_qR1bv1nqKwOJr2NiWpi`,
	"fill": `ybkB2GepA7qNSa21FsUk`,
	"contain": `YUOqXuq4Q7KZONomHoc2`,
	"cover": `p_YJwGjxRxZ4QiBp3jop`,
	"blocked": `Xe3U6sh4wiTXgNJfwetJ`
};
export default ___CSS_LOADER_EXPORT___;
